'use client';

import type { JSX, ReactNode } from 'react';

/**
 * En-tête d'issue de réservation, partagé par le tunnel booking classique ET le tunnel VTC :
 * la carte `bt-confirmed` (icône + titre + message). Source UNIQUE de ce DOM — avant, il était
 * dupliqué entre `BookingSuccess` (couplé au BookingContext) et l'écran de succès du tunnel VTC
 * (props-driven, mais icône `✓` codée en dur, donc jamais de sablier même en attente).
 *
 * - `awaitingConfirmation` : le pro doit encore valider (réservation en WAITING_CONFIRMATION) →
 *   sablier ⏳ au lieu du ✓, pour ne pas annoncer une confirmation ferme alors qu'elle est en attente.
 * - `title` optionnel : omis (ex. statut encore en cours de résolution) → aucun titre rendu, pour
 *   éviter un flash « confirmée » avant de connaître le vrai statut.
 * - `footer` : contenu additionnel DANS la carte (ex. lien « gérer ma réservation »).
 * - `children` : récapitulatif enrichi rendu SOUS la carte (carte trajet, vue de gestion inline…).
 */
export function BookingOutcome({
  awaitingConfirmation = false,
  title,
  message,
  withManage = false,
  footer,
  children,
}: {
  awaitingConfirmation?: boolean;
  title?: string;
  message?: string;
  withManage?: boolean;
  footer?: ReactNode;
  children?: ReactNode;
}): JSX.Element {
  return (
    <div className="bt-step">
      <div className={withManage ? 'bt-confirmed bt-confirmed--with-manage' : 'bt-confirmed'}>
        <div className="bt-confirmed__icon">{awaitingConfirmation ? '⏳' : '✓'}</div>
        {title ? <div className="bt-confirmed__title">{title}</div> : null}
        {message ? <div className="bt-confirmed__message">{message}</div> : null}
        {footer}
      </div>
      {children}
    </div>
  );
}
